/**
 * @param {Record<string, string> | null | undefined} prestador
 * @returns {string}
 */
export function formatPrestadorAddress(prestador) {
  if (!prestador || typeof prestador !== "object") {
    return "";
  }
  const locality = [prestador.codigoPostal, prestador.ciudad]
    .filter((part) => typeof part === "string" && part.trim())
    .join(" ")
    .trim();
  return [prestador.direccion, locality, prestador.provincia, prestador.pais]
    .filter((part) => typeof part === "string" && part.trim())
    .join(", ");
}

/**
 * @param {Record<string, string> | null | undefined} prestador
 * @returns {{
 *   nombreFiscal: string,
 *   nif: string,
 *   domicilio: string,
 *   email: string,
 *   telefono: string,
 *   hasIdentity: boolean,
 * }}
 */
export function buildPrestadorIdentity(prestador) {
  const source = prestador && typeof prestador === "object" ? prestador : {};
  const nombreFiscal = typeof source.nombreFiscal === "string" ? source.nombreFiscal.trim() : "";
  const nif = typeof source.nif === "string" ? source.nif.trim() : "";
  const domicilio = formatPrestadorAddress(source);
  const email = typeof source.emailFacturacion === "string" ? source.emailFacturacion.trim() : "";
  const telefono = typeof source.telefonoFacturacion === "string" ? source.telefonoFacturacion.trim() : "";
  return {
    nombreFiscal,
    nif,
    domicilio,
    email,
    telefono,
    hasIdentity: Boolean(nombreFiscal || nif || domicilio || email || telefono),
  };
}
